export default __webpack_public_path__ + "static/media/logo-login.8d8a2b6c.svg";